import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[smNumericOnly]'
})
export class NumericOnlyDirective {


  constructor(private el: ElementRef, private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputValue = this.el.nativeElement.value;
    const numericValue = inputValue.replace(/[^0-9]*/g, '');

    // Set the element's value to the numeric value
    this.el.nativeElement.value = numericValue;

    // Update the Angular control's value to ensure the model is updated correctly
    if (this.ngControl.control) {
      this.ngControl.control.setValue(numericValue);
    }
  }

}

